'use client';

import { twMerge } from '@shared/themes';
import { useElementSizes, useIsMobile, useOffsetHeaders } from '@shared/utils';
import { type ComponentProps, useRef } from 'react';
import { useElementScroll } from '../../hooks';

type SecondaryHeaderContainerProps = ComponentProps<'div'> & {
  children: React.ReactNode;
};

function SecondaryHeaderClient({ children, className, ...props }: SecondaryHeaderContainerProps) {
  const headerRef = useRef<HTMLDivElement>(null);
  const { height } = useElementSizes(headerRef);
  const { scrollPosition, scrollDirection } = useElementScroll({});
  const isMobile = useIsMobile({ breakpoint: 'md' });

  const { offsetPageToolbar } = useOffsetHeaders();

  const enableAnimation = isMobile ? scrollPosition > height + offsetPageToolbar : scrollPosition > height;

  const CLASSES = `${isMobile && !(scrollPosition > offsetPageToolbar) ? '' : 'bg-background/95 sticky left-0 right-0 z-20'}
    ${enableAnimation ? (scrollDirection === 'UP' ? 'animate-secondary-header-fade-in' : 'animate-secondary-header-fade-out') : ''}`;

  return (
    <div
      ref={headerRef}
      className={twMerge('ll-grid-container py-6 top-0 md:top-[calc(var(--sticky-primary-header-height,0px)+var(--sticky-page-toolbar-height,0px))]', CLASSES, className)}
      {...props}
      data-testid="secondary-header-client"
    >
      {children}
    </div>
  );
}

export { SecondaryHeaderClient };
